import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import API, { useCsrfToken } from '@wheeebo/polaris-api';
import { useErrorHandler } from '../../errorHandler';
import Map from './Map';
import useMap from './useMap';
function FlightPathMap({ apiKey, flightPathId, editable, hideAllUIs, onMapClick }) {
    const { loaded, setBounds } = useMap();
    const [initialized, setInitialized] = React.useState(false);
    const { csrfToken } = useCsrfToken();
    const { showAndEmitJsErrorEvent } = useErrorHandler();
    const queryClient = useQueryClient();
    const { data, isLoading } = useQuery(API.Waypoints.listKey(flightPathId, {}), () => API.Waypoints.list(flightPathId, {}));
    const { mutate: updateWaypoint } = useMutation((holder) => API.Waypoints.update(csrfToken, holder.waypointId, holder.options), {
        onSuccess: () => {
            queryClient.invalidateQueries(API.FlightPaths.CacheKey);
            queryClient.invalidateQueries(API.Waypoints.CacheKey);
        },
        onError: showAndEmitJsErrorEvent,
    });
    const handleDragEnd = React.useCallback((waypointId, coords) => {
        updateWaypoint({ waypointId, options: { latitude: coords.lat, longitude: coords.lng } });
    }, [updateWaypoint]);
    React.useEffect(() => {
        if (!loaded || initialized) {
            return;
        }
        const coords = data?.items.map((e) => e.location);
        if (coords) {
            setBounds?.(coords);
        }
        setInitialized(true);
    }, [initialized, data?.items, loaded, setBounds]);
    return (React.createElement(Map, { apiKey: apiKey, waypoints: data?.items, locked: !editable || isLoading, hideAllUIs: hideAllUIs, onDragEnd: handleDragEnd, onClick: editable ? onMapClick : undefined, draggable: true }));
}
export default React.memo(FlightPathMap);
